const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function detectPlatform() {
  const ua = navigator.userAgent || '';
  if (/MayaPlusFireTV/i.test(ua)) return { platform: 'firetv', version: (ua.match(/MayaPlusFireTV\/([\d.]+)/i) || [])[1] || '' };
  if (/MayaPlusAndroidTV/i.test(ua)) return { platform: 'googletv', version: (ua.match(/MayaPlusAndroidTV\/([\d.]+)/i) || [])[1] || '' };
  if (/MayaPlusAppleTV/i.test(ua)) return { platform: 'appletv', version: (ua.match(/MayaPlusAppleTV\/([\d.]+)/i) || [])[1] || '' };
  if (/Web0S|webOS/i.test(ua) && /TV/i.test(ua)) return { platform: 'lg', version: '' };
  if (/Tizen/i.test(ua)) return { platform: 'samsung', version: '' };
  // App mobile (WebView) : Android "wv" ou iOS sans Safari
  if (/Android/i.test(ua) && /\bwv\b/i.test(ua)) return { platform: 'android_app', version: '' };
  const iOS = /iPhone|iPad|iPod/i.test(ua);
  if (iOS && !/Safari/i.test(ua)) return { platform: 'ios_app', version: '' };
  if (iOS && window.navigator.standalone === true) return { platform: 'ios_app', version: '' };
  return null;
}

export function reportAppLaunch() {
  try {
    const det = detectPlatform();
    if (!det) return;
    let id = localStorage.getItem('maya_device_uid');
    if (!id) {
      id = 'dev-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem('maya_device_uid', id);
    }
    fetch(`${API}/app-launch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ device_id: id, ...det }),
    }).catch(() => {});
  } catch (e) { /* silencieux */ }
}
